import React from "react";
import { useTranslation } from "react-i18next";
import { Comment, comment as commentMock } from "@planzone/dto";
import { useAuthentication, useStartDiscussion } from "@planzone/view-models";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { TextInput } from "@common/textInput";
import { RecipientInput } from "./recipientInput";
import { Props } from "./types";
import styles from "./styles.scss";

function StartDiscussion({ project, cancel }: Props) {
  const { t } = useTranslation();
  const { account } = useAuthentication();
  const { isRequestPending, startDiscussion } = useStartDiscussion(project);
  const [name, setName] = React.useState("");
  const [comment, setComment] = React.useState<Comment>(commentMock);

  return (
    <WorkspaceContext type="project" project={project}>
      <Modal header={t("startDiscussion.title")} close={cancel}>
        <form
          className={styles.main}
          onSubmit={(e) => {
            e.preventDefault();

            !isRequestPending &&
              startDiscussion({
                name,
                initialComment: { ...comment, author: account.resource },
                project,
              });
          }}
        >
          <div className={styles.form}>
            <div className={styles.group}>
              <p className={styles.title}>{t("startDiscussion.subject")}</p>
              <TextInput value={name} placeholder="" input={setName} />
            </div>
            <div className={styles.group}>
              <p className={styles.title}>{t("startDiscussion.comment")}</p>
              <TextInput
                value={comment.content}
                className={styles.textArea}
                placeholder=""
                input={(content) => setComment({ ...comment, content })}
                isMultiline
              />
            </div>
            <div className={styles.group}>
              <p className={styles.title}>
                {t("startDiscussion.recipients")}:{" "}
              </p>
              <RecipientInput
                recipients={comment.recipients}
                input={(recipients) => setComment({ ...comment, recipients })}
              />
            </div>
          </div>
          <div className={styles.buttons}>
            <Button type="cancel" press={cancel}>
              {t("startDiscussion.cancel")}
            </Button>
            <Button
              type="submit"
              status={isRequestPending ? "pending" : "none"}
              isDisabled={isRequestPending}
            >
              {t("startDiscussion.submit")}
            </Button>
          </div>
        </form>
      </Modal>
    </WorkspaceContext>
  );
}

export { StartDiscussion };
